import Vue from "vue";
import Router from "vue-router";
// import { DefaultLayout } from '@/layouts';
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "@/store";

import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css";
NProgress.configure({ showSpinner: false });
Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: "/",
      name: "Inicio",
      component: () => import("@/views/Inicio"),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/Investigador/Bandeja",
      name: "BandejaProtocolosProyectos",
      component: () =>
        import("@/views/Investigador/BandejaProtocolosProyectos"),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/RevisionProtocolosProyectos/Bandeja",
      name: "BandejaRevisionProtocolosProyectos",
      component: () =>
        import(
          "@/views/RevisionProtocolosProyectos/BandejaRevisionProtocolosProyectos"
        ),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/EvaluacionProtocolosProyectos/Bandeja",
      name: "BandejaEvaluacionProtocolosProyectos",
      component: () =>
        import(
          "@/views/EvaluacionProtocolosProyectos/BandejaEvaluacionProtocolosProyectos"
        ),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/BandejaPeriodos",
      name: "BandejaConvocatorias",
      component: () => import("@/views/BandejaConvocatorias"),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/BandejaEnvioCorreos",
      name: "BandejaEnvioCorreos",
      component: () => import("@/views/BandejaEnvioCorreos"),
      meta: {
        isPublic: false,
      },
    },
    {
      path:
        "/Catalogos/DialogConvocatoriasEditar/idAccion/:idAccion/idConvocatoria/:idConvocatoria",
      name: "DialogConvocatoriasEditar",
      component: () =>
        import("../components/catalogos/DialogConvocatoriasEditar"),
      props: ({ params }) => ({
        idAccion: Number.parseInt(params.idAccion, 10) || 0,
        idConvocatoria: Number.parseInt(params.idConvocatoria, 10) || 0,
      }),
      meta: {
        isPublic: false,
      },
    },
    {
      path:
        "/Investigador/FormularioProtocoloProyecto/idAccion/:idAccion/idProyecto/:idProyecto",
      name: "InvFormularioProtocoloProyecto",
      component: () =>
        import("@/views/Investigador/FormularioProtocoloProyecto"),
      props: ({ params }) => ({
        idAccion: Number.parseInt(params.idAccion, 10) || 0,
        idProyecto: Number.parseInt(params.idProyecto, 10) || 0,
      }),
      meta: {
        isPublic: false,
      },
    },
    {
      path:
        "/RevisionProtocolosProyectos/FormularioProtocoloProyecto/idProyecto/:idProyecto",
      name: "RevisionFormularioProtocoloProyecto",
      component: () =>
        import(
          "@/views/RevisionProtocolosProyectos/FormularioProtocoloProyecto"
        ),
      props: ({ params }) => ({
        idProyecto: Number.parseInt(params.idProyecto, 10) || 0,
      }),
      meta: {
        isPublic: false,
      },
    },
    {
      path:
        "/EvaluacionProtocolosProyectos/FormularioProtocoloProyecto/idProyecto/:idProyecto",
      name: "EvaluacionFormularioProtocoloProyecto",
      component: () =>
        import(
          "@/views/EvaluacionProtocolosProyectos/FormularioProtocoloProyecto"
        ),
      props: ({ params }) => ({
        idProyecto: Number.parseInt(params.idProyecto, 10) || 0,
      }),
      meta: {
        isPublic: false,
      },
    },
    {
      path: "/oidc-callback", // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
      name: "oidcCallback",
      component: () =>
        import(/* webpackChunkName: "oidc" */ "@/views/oidc/OidcCallback"),
      meta: {
        isOidcCallback: true,
        isPublic: true,
      },
    },
    {
      path: "/oidc-callback-error", // Needs to match redirect_uri in you oidcSettings
      name: "oidcCallbackError",
      component: () =>
        import(
          /* webpackChunkName: "oidc_error" */ "@/views/oidc/OidcCallbackError"
        ),
      meta: {
        isPublic: true,
      },
    },
    {
      path: "*",
      component: () => import("@/views/404"),
      meta: {
        admin: false,
      },
    },
  ],
});

// Midleware oidc

router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidc"));

// Barra de progreso

router.beforeEach((to, from, next) => {
  // console.log(store._modules)
  NProgress.start();
  /* if (to.matched.some(r => r.meta.admin)) {
    if (store.getters['permiso/administrador']) {
      next();
      return;
    }
    next('/');
  }
  else { */
  next();
  //}
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
